var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-toast flex-column"},[_c('img',{attrs:{"src":_vm.toastData.imgUrl,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.toastData.txt))])]),_c('div',{staticClass:"toast-mask"})])}
var staticRenderFns = []

export { render, staticRenderFns }